import store from '../../store'
/**
 * @Description: 接收参数，全局提供一个
 * @param {type} 
 * @return: null
 */
const InitAppMessage = () => {
    if (store.state.appMessageInit) {
        console.warn('通信模块不可重复初始化！');
        return;
    }
    const handleMessage = (message) => {
        const options = message['data'];
        const code = options['code'];
        const eventType = options['event'];
        const params = options['params'];
        // 过滤不是本应用的消息
        if (code == store.state.code) {
          let callbacks = store.state.appMessageCallbaks[eventType];
            if (callbacks) {
                for(let index=0,len=callbacks.length;index<len;index++){
                  callbacks[index].fn({ params });
                  if (typeof callbacks[index] != "undefined" && callbacks[index].once) {
                    store.dispatch('removeAppMessageCallBacks', { eventType, index });
                    break;
                  }
                }
            }
        }
    }
    if (window.addEventListener) {
        window.addEventListener("message", handleMessage);
    } else {
        window.attachEvent("onmessage", handleMessage);
    }
    store.dispatch('setAppMessageInit');
}

export default InitAppMessage;